import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../assets/package.json'
import {HeaderComponent} from './components/header/header.component'


@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent
  ],
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public readonly configService = inject(ConfigService)
  public version = version.version
}